import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchDashboardStats } from '@/renderer/services/accommodationService';

export function useDashboardStats(
  propertyId: string | null | undefined,
  dateFrom: string,
  dateTo: string,
) {
  return useQuery({
    queryKey: queryKeys.accommodation.dashboardStats(
      propertyId ?? '',
      dateFrom,
      dateTo,
    ),
    queryFn: () => fetchDashboardStats(propertyId!, dateFrom, dateTo),
    enabled: !!propertyId && !!dateFrom && !!dateTo,
    staleTime: 1000 * 60 * 5,
  });
}
